// Add your custom JS here.
jQuery(function ($) {
    let isScrolled = false;

    $(window).on("scroll", function () {
        const scroll = $(window).scrollTop();
        const header = $("header.header-site");

        if (!isScrolled && scroll > 60) {
            isScrolled = true;
            header.addClass("scrolled");
        } else if (isScrolled && scroll < 20) {
            isScrolled = false;
            header.removeClass("scrolled");
        }
    });
});

jQuery(document).ready(function ($) {
    $('[tabindex="0"]').keydown(function (event) {
        if (event.key === "Enter" || event.key === " ") {
            $(this).click();
        }
    });
});

/*skip content*/
document.addEventListener("DOMContentLoaded", function () {
    const LinkGoSecondSection = document.getElementById("GoSecondSection");
    LinkGoSecondSection.addEventListener("click", function (event) {
        event.preventDefault();
        const secondSection = document.querySelector(
            ".general-section:nth-of-type(2)",
        );
        if (secondSection) {
            secondSection.scrollIntoView({ behavior: "smooth" });
        } else {
            console.error("the second section was not found.");
        }
    });
});

function autosize() {
    var el = this;
    setTimeout(function () {
        el.style.cssText = "height:auto; padding:0";
        // for box-sizing other than "content-box" use:
        // el.style.cssText = '-moz-box-sizing:content-box';
        el.style.cssText = "height:" + (el.scrollHeight + 2) + "px";
    }, 0);
}

// AOS (Animate On Scroll) refresh on AJAX content load
document.addEventListener("DOMContentLoaded", function () {
    if (typeof AOS === "undefined") return;
    jQuery(document).on("sf:ajaxfinish", function () {
        AOS.refreshHard();
    });

    var target = document.querySelector("#block-search-and-filter");
    if (target) {
        var resizeObserver = new ResizeObserver(function () {
            AOS.refreshHard();
        });
        resizeObserver.observe(target);
    }
});

//  Smooth scroll for hash links
document.addEventListener("DOMContentLoaded", function () {
    const isMobile = window.innerWidth < 992;
    const offset = isMobile ? 180 : 230;

    function scrollToHash(hash) {
        const el = document.querySelector(hash);
        if (el) {
            setTimeout(() => {
                window.scrollTo({
                    top:
                        el.getBoundingClientRect().top +
                        window.pageYOffset -
                        offset,
                    behavior: "smooth",
                });
            }, 50);
        }
    }

    if (window.location.hash) {
        scrollToHash(window.location.hash);
    }

    document.querySelectorAll('a[href^="#"]').forEach((link) => {
        link.addEventListener("click", function (e) {
            const hash = this.getAttribute("href");
            if (hash.length > 1) {
                e.preventDefault();
                history.pushState(null, null, hash);
                scrollToHash(hash);
            }
        });
    });
});

// Header Buttons in Mega Menu Mobile
document.addEventListener("DOMContentLoaded", function () {
    const headerButtons = document.querySelector(".header-buttons");
    const megaMenu = document.querySelector("#mega-menu-primary");

    const liButtons = document.createElement("li");
    liButtons.className =
        "mega-menu-item mega-menu-item-type-custom mega-align-bottom-left mega-menu-flyout menu-item-header-buttons";

    let isInMegaMenu = false;

    function moveButtonsToMenu() {
        if (window.innerWidth <= 1000 && !isInMegaMenu) {
            if (headerButtons && megaMenu) {
                liButtons.appendChild(headerButtons);
                megaMenu.appendChild(liButtons);
                isInMegaMenu = true;
            }
        } else if (window.innerWidth > 1000 && isInMegaMenu) {
            const originalContainer =
                document.querySelector(".content-elements");
            if (originalContainer && headerButtons) {
                originalContainer.appendChild(headerButtons);
                if (liButtons.parentNode)
                    liButtons.parentNode.removeChild(liButtons);
                isInMegaMenu = false;
            }
        }
    }

    moveButtonsToMenu();
    window.addEventListener("resize", moveButtonsToMenu);
});

// Lenis Smooth Scroll
document.addEventListener("DOMContentLoaded", function () {
    // Initialize Lenis
    const lenis = new Lenis({
        autoRaf: true,
    });

    // Listen for the scroll event and log the event data
    lenis.on("scroll", (e) => {
        console.log(e);
    });
});
//spotlight products
jQuery(document).ready(function ($) {
    $(".products-slick").each(function () {
        var $slick = $(this);

        var $controls = $slick
            .closest(".products-slider-wrapper")
            .next(".container-pagination")
            .find(".slider-controls");

        if (!$controls.length) {
            $controls = $slick
                .closest("section")
                .find(".container-pagination .slider-controls")
                .first();
        }

        var $current = $controls.find(".slider-pagination .current");
        var $total = $controls.find(".slider-pagination .total");
        var $prevArrow = $controls.find(".arrow-prev");
        var $nextArrow = $controls.find(".arrow-next");

        $slick.on("init", function (event, slick) {
            if ($total.length) $total.text(slick.slideCount);
            if ($current.length) $current.text(slick.currentSlide + 1);
        });

        $slick.on("afterChange", function (event, slick, currentSlide) {
            if ($current.length) $current.text(currentSlide + 1);
        });

        $slick.slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: false,
            centerPadding: "0px",
            arrows: true,
            dots: false,
            prevArrow: $prevArrow.length ? $prevArrow : null,
            nextArrow: $nextArrow.length ? $nextArrow : null,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        centerMode: false,
                        centerPadding: "0px",
                    },
                },
                {
                    breakpoint: 991,
                    settings: {
                        centerMode: false,
                        centerPadding: "0px",
                    },
                },
            ],
        });

        if ($slick.hasClass("slick-initialized")) {
            var slickObj = $slick.get(0).slick;
            if (slickObj) {
                if ($total.length) $total.text(slickObj.slideCount);
                if ($current.length) $current.text(slickObj.currentSlide + 1);
            }
        }
    });
});

//**  Menu search sku */
jQuery(function ($) {
    let activeIndex = -1;
    let $items = $();
    let currentRequest = null;

    /* =========================
     * SEARCH (ONLY TEXT INPUT)
     * ========================= */
    $(".sku-search").on("keyup", function (e) {
        if (["ArrowUp", "ArrowDown", "Enter", "Escape"].includes(e.key)) {
            return;
        }

        const search = $(this).val().trim();

        if (!search.length) {
            resetResults();
            return;
        }

        $(".sku-search-wrapper").addClass("searching");
        $(".sku-results").addClass("loading");

        if (currentRequest) {
            currentRequest.abort();
        }

        currentRequest = $.ajax({
            url: sku_search_ajax.ajax_url,
            type: "POST",
            data: {
                action: "search_by_sku",
                search: search,
            },
            success: function (response) {
                try {
                    response = JSON.parse(response);
                } catch {
                    showError();
                    return;
                }

                activeIndex = -1;
                $(".sku-results").empty().show();

                if (!response.length) {
                    $(".sku-results").append("<li>No results</li>");
                    stopLoading();
                    return;
                }

                response.forEach((item) => {
                    $(".sku-results").append(`
                        <li>
                            <a href="${item.url}">
                                ${highlightMatch(item.sku, search)}
                            </a>
                        </li>
                    `);
                });

                $items = $(".sku-results li");
                stopLoading();
            },
        });
    });

    /* =========================
     * KEYBOARD NAVIGATION
     * ========================= */
    $(".sku-search").on("keydown", function (e) {
        if (!$items.length) return;

        if (e.key === "ArrowDown" || e.key === "ArrowUp") {
            e.preventDefault();

            activeIndex =
                e.key === "ArrowDown"
                    ? Math.min(activeIndex + 1, $items.length - 1)
                    : Math.max(activeIndex - 1, 0);

            updateActive();
            ensureVisible();
        }

        if (e.key === "Enter") {
            e.preventDefault();

            const index = activeIndex >= 0 ? activeIndex : 0;
            const url = $items.eq(index).find("a").attr("href");
            if (url) window.location.href = url;
        }

        if (e.key === "Escape") {
            resetResults();
        }
    });

    /* =========================
     * CLICK OUTSIDE
     * ========================= */
    $(document).on("click", function (e) {
        if (!$(e.target).closest(".sku-search-wrapper").length) {
            resetResults();
        }
    });

    /* =========================
     * CLEAR INPUT
     * ========================= */
    const clearBtn = $(".clear-input");

    $(".sku-search").on("input", function () {
        clearBtn.toggle($(this).val().length > 0);
    });

    clearBtn.on("click", function () {
        $(".sku-search").val("").focus();
        resetResults();
        clearBtn.hide();
    });

    /* =========================
     * HELPERS
     * ========================= */
    function updateActive() {
        $items.removeClass("active");
        if (activeIndex >= 0) {
            $items.eq(activeIndex).addClass("active");
        }
    }

    function ensureVisible() {
        const $container = $(".sku-results");
        const $active = $items.eq(activeIndex);

        if (!$active.length) return;

        const top = $active.position().top;
        const bottom = top + $active.outerHeight();

        if (top < 0) {
            $container.scrollTop($container.scrollTop() + top);
        } else if (bottom > $container.height()) {
            $container.scrollTop(
                $container.scrollTop() + (bottom - $container.height()),
            );
        }
    }

    function highlightMatch(text, search) {
        return text.replace(
            new RegExp(search, "gi"),
            (m) => `<mark>${m}</mark>`,
        );
    }

    function resetResults() {
        $(".sku-results").hide().empty().scrollTop(0);
        $(".sku-search-wrapper").removeClass("searching");
        $(".sku-results").removeClass("loading");
        activeIndex = -1;
        $items = $();
    }

    function showError() {
        $(".sku-results").show().html("<li>Error</li>");
        stopLoading();
    }

    function stopLoading() {
        $(".sku-search-wrapper").removeClass("searching");
        $(".sku-results").removeClass("loading");
    }
});

jQuery(document).ready(function ($) {
    var $slider = $(".hero-resource-slider");
    var $current = $(".slider-num .current");
    var $total = $(".slider-num .total");

    $slider.on("init", function (event, slick) {
        $total.text(slick.slideCount);
        $current.text(slick.currentSlide + 1);
    });

    $slider.on("afterChange", function (event, slick, currentSlide) {
        $current.text(currentSlide + 1);
    });

    $slider.slick({
        slidesToShow: 1,
        autoplay: false,
        dots: false,
        arrows: false,
        adaptiveHeight: true,
    });

    $(".arrow-prev").on("click", function () {
        $slider.slick("slickPrev");
    });

    $(".arrow-next").on("click", function () {
        $slider.slick("slickNext");
    });

    //slider related product
    $(".products-slider-related").slick({
        dots: false,
        infinite: false,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        lazyLoad: "ondemand",
        responsive: [
            {
                breakpoint: 1100,
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 900,
                settings: {
                    slidesToShow: 2,
                    autoplay: true,
                },
            },
            {
                breakpoint: 570,
                settings: {
                    slidesToShow: 1,
                    autoplay: true,
                },
            },
        ],
    });
});

//custom File input
function initCustomUpload(field) {
    if (field.classList.contains("custom-upload-initialized")) return;

    const inputFile = field.querySelector('input[type="file"]');
    if (!inputFile) return;

    field.classList.add("custom-upload-initialized");

    const wrapper = document.createElement("div");
    wrapper.className = "custom-upload-wrapper";

    const button = document.createElement("button");
    button.type = "button";
    button.className = "custom-upload-btn";
    button.innerText = "PHOTO UPLOAD";

    const fileName = document.createElement("span");
    fileName.className = "upload-file-name";
    fileName.innerHTML =
        "<strong>Photo upload:</strong> Add photos of your current chain assembly (optional but recommended)";

    wrapper.appendChild(button);
    wrapper.appendChild(fileName);
    field.appendChild(wrapper);

    button.addEventListener("click", () => inputFile.click());

    inputFile.addEventListener("change", () => {
        fileName.innerText = inputFile.files.length
            ? inputFile.files[0].name
            : "PHOTO UPLOAD";
    });
}

document.addEventListener("DOMContentLoaded", () => {
    document
        .querySelectorAll(".custom-upload-field, .hs-fieldtype-file")
        .forEach(initCustomUpload);
});

const observer = new MutationObserver(() => {
    document
        .querySelectorAll(".custom-upload-field, .hs-fieldtype-file")
        .forEach(initCustomUpload);
});

observer.observe(document.body, {
    childList: true,
    subtree: true,
});

// guide-step-media-content.php slider
jQuery(document).ready(function ($) {
    $(".guide-step-gallery-slider").each(function () {
        var $slider = $(this);

        $slider.on("init setPosition", function () {
            if (typeof AOS !== "undefined") {
                AOS.refresh();
            }
        });

        $slider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: true,
        });
    });

    jQuery(function ($) {
        function applyModelParam() {
            const params = new URLSearchParams(window.location.search);
            const model = params.get("_pa_model");
            if (!model) return;

            $(".result-card .link-product").each(function () {
                const $link = $(this);
                const href = $link.attr("href");
                if (!href) return;

                const url = new URL(href, window.location.origin);

                if (!url.searchParams.has("_pa_model")) {
                    url.searchParams.set("_pa_model", model);
                    $link.attr("href", url.toString());
                }
            });
        }

        applyModelParam();
        const observer = new MutationObserver(function () {
            applyModelParam();
        });
        observer.observe(document.body, {
            childList: true,
            subtree: true,
        });
    });
});

//refresh aos body
jQuery(document).ready(function ($) {
    let lastHeight = $("body").height();

    function refreshAOSSimple() {
        if (window.AOS && typeof window.AOS.refresh === "function") {
            window.AOS.refresh();
            $(window).scrollTop($(window).scrollTop() + 1);
            $(window).scrollTop($(window).scrollTop() - 1);
            return true;
        }
        return false;
    }

    setInterval(function () {
        const currentHeight = $("body").height();
        if (Math.abs(currentHeight - lastHeight) > 30) {
            lastHeight = currentHeight;
            refreshAOSSimple();
        }
    }, 1000);

    $(document).on("sf:ajaxfinish", function () {
        setTimeout(function () {
            const newHeight = $("body").height();
            lastHeight = newHeight;
            refreshAOSSimple();
        }, 600);
    });

    setTimeout(refreshAOSSimple, 2000);
});

/** language selector custom */
document.addEventListener("DOMContentLoaded", function () {
    const selects = document.querySelectorAll(".custom-select-translate");

    selects.forEach((selectTranslate) => {
        const selectedTranslate =
            selectTranslate.querySelector(".select-selected");
        const itemsTranslate = selectTranslate.querySelector(".select-items");

        // Open/close drop-down menu
        selectedTranslate.addEventListener("click", (e) => {
            e.stopPropagation();
            document
                .querySelectorAll(".custom-select-translate .select-items")
                .forEach((drop) => {
                    if (drop !== itemsTranslate)
                        drop.classList.add("select-hide");
                });
            itemsTranslate.classList.toggle("select-hide");
        });

        // Handle selection
        itemsTranslate.querySelectorAll("div").forEach((option) => {
            option.addEventListener("click", (e) => {
                e.stopPropagation();

                // Find the link <a> generated by [gt-link]
                const link = option.querySelector("a");
                if (link) {
                    link.click();
                }

                // Update the visual of the select
                selectedTranslate.innerHTML = option.innerHTML;
                itemsTranslate.classList.add("select-hide");
            });
        });
    });

    // Close dropdown if clicked outside
    document.addEventListener("click", () => {
        document
            .querySelectorAll(".custom-select-translate .select-items")
            .forEach((drop) => {
                drop.classList.add("select-hide");
            });
    });
});

/**document.addEventListener("DOMContentLoaded", function () {
    const defaultLang = "en";
    document.cookie = `googtrans=/auto/${defaultLang};path=/`;
    document.cookie = `googtrans=/auto/${defaultLang};path=/;domain=${location.hostname}`;
}); **/

(function ($) {
    function checkActiveSlide() {
        var $slide = $(".single-product .woocommerce-product-gallery__image");
        if (!$slide.length) return;

        var $link = $slide.find("a");
        if (!$link.length) return;

        var url = $link.attr("href") || "";

        if (/\.(jpg|jpeg)(\?.*)?$/i.test(url)) {
            $slide.addClass("img-jpg-woocommerce");
        } else {
            $slide.removeClass("img-jpg-woocommerce");
        }
    }

    const observer = new MutationObserver(function () {
        checkActiveSlide();
    });

    const waitForGallery = setInterval(function () {
        const gallery = document.querySelector(".woocommerce-product-gallery");
        if (!gallery) return;

        clearInterval(waitForGallery);

        observer.observe(gallery, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ["class"],
        });

        checkActiveSlide();
    }, 300);
})(jQuery);

// function checkboxx all in child
document.addEventListener("DOMContentLoaded", () => {
    function addAllCheckboxes() {
        const allCheckboxes = document.querySelectorAll(
            ".search-filter-input-checkbox:not(.terminator-item)",
        );

        allCheckboxes.forEach((el) => {
            const hasGroup = el.querySelector(
                ":scope > .search-filter-input-group",
            );

            if (hasGroup) {
                el.classList.add("level-accordion");
                el.classList.remove("not-accordion");
            } else {
                el.classList.remove("level-accordion");
                el.classList.add("not-accordion");

                if (!el.querySelector(".item-not-accordion")) {
                    const wrapper = document.createElement("div");
                    wrapper.className = "item-not-accordion";

                    const labelElement = el.querySelector(
                        ".search-filter-input-checkbox__label",
                    );
                    const terminatorText = labelElement
                        ? labelElement.textContent.trim()
                        : "";

                    const span = document.createElement("span");
                    span.className = "check-all";
                    span.textContent = "All " + terminatorText;

                    wrapper.appendChild(span);
                    el.appendChild(wrapper);
                }
            }
        });
    }

    addAllCheckboxes();

    let timeout;
    const observer = new MutationObserver(() => {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
            observer.disconnect();
            addAllCheckboxes();
            observer.observe(document.body, { subtree: true, childList: true });
        }, 50);
    });

    observer.observe(document.body, { subtree: true, childList: true });
});


// Accordion not accordion - items all checkbox 
document.addEventListener('DOMContentLoaded', () => {
    function initAccordionsForAllItems() {
        const itemsWithAll = document.querySelectorAll('.search-filter-input-checkbox > .item-not-accordion');
        
        itemsWithAll.forEach(childContent => {
            const parentCheckbox = childContent.parentElement;
            
            if (parentCheckbox.querySelector(':scope > .search-filter-input-group')) {
                return;
            }
            
            if (parentCheckbox.hasAttribute('data-all-accordion')) {
                return;
            }
            
            parentCheckbox.setAttribute('data-all-accordion', 'true');
            
            const label = parentCheckbox.querySelector('.search-filter-input-checkbox__label');
            if (!label) return;
            
            childContent.style.display = 'block';
            parentCheckbox.classList.add('is-open');
            parentCheckbox.classList.remove('is-collapsed');
            
            label.onclick = function(e) {
                if (e.target.type === 'checkbox') {
                    return;
                }
                
                e.preventDefault();
                e.stopPropagation();
                
                const isOpen = parentCheckbox.classList.contains('is-open');
                
                if (isOpen) {
                    childContent.style.display = 'none';
                    parentCheckbox.classList.remove('is-open');
                    parentCheckbox.classList.add('is-collapsed');
                } else {
                    childContent.style.display = 'block';
                    parentCheckbox.classList.add('is-open');
                    parentCheckbox.classList.remove('is-collapsed');
                }
            };
        });
    }
    initAccordionsForAllItems();
    
    let timeout;
    const observer = new MutationObserver(() => {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
            observer.disconnect();
            initAccordionsForAllItems();
            observer.observe(document.body, {subtree: true, childList: true});
        }, 50);
    });
    
    observer.observe(document.body, {subtree: true, childList: true});
});


// Fixed aesthetic content for tags
function fixFilterLabels() {
    document.querySelectorAll(".search-filter-input-button").forEach(function (btn) {
        const value = btn.getAttribute("data-option-value");
        if (!value) return;
        
        const label = value.split("/").pop();
        let formatted = label;

        const exceptions = {
            "_sku+asc": "sort part number",
            "date+desc": "sort newest",
            "title+asc": "sort name A-Z",
            "title+desc": "sort name Z-A",
        };

        let isException = false;

        if (exceptions[label]) {
            formatted = exceptions[label];
            isException = true;
        }
        else if (exceptions[formatted]) {
            formatted = exceptions[formatted];
            isException = true;
        }

        if (!isException) {
            if (formatted.startsWith("_")) {
                formatted = "#" + formatted.slice(1);
            }

            const isShortNumberPattern = /^\d{1,2}-\d$/.test(label);
            if (isShortNumberPattern) {
                formatted = formatted.replace("-", "+");
            } 
            else if (/^\d+-\d+$/.test(label)) {
                formatted = formatted.replace("-", ".");
            } 
            else if (/[a-zA-Z]/.test(label)) {
                formatted = formatted.replace(/-2$/, "");
                formatted = formatted.replace(/(\d+)-(\d{2,3})(?=-|$)/g, "$1.$2");
                formatted = formatted.replace(/-/g, " ");
            }
        }

        btn.childNodes.forEach(function (node) {
            if (node.nodeType === 3) {
                node.nodeValue = formatted;
            }
        });
    });
}
setInterval(fixFilterLabels, 500);

jQuery(document).ready(function ($) {
    window.addEventListener("message", function (event) {
        if (
            event.data &&
            event.data.type === "hsFormCallback" &&
            event.data.eventName === "onFormSubmitted"
        ) {
            setTimeout(function () {
                $(".submitted-message, .submitted-message *").css(
                    "color",
                    "#000",
                );

                $("iframe.hs-form-iframe").each(function () {
                    try {
                        var iframeDoc =
                            this.contentDocument || this.contentWindow.document;

                        $(iframeDoc)
                            .find(".submitted-message, .submitted-message *")
                            .css("color", "#000");
                    } catch (e) {}
                });
            }, 150);
        }
    });
});

// move button reset tag to filtered results side
document.addEventListener("DOMContentLoaded", function () {
    const resetTag = document.querySelector(".reset-tag");
    const counterReset = document.querySelector(".counter-reset");

    if (resetTag && counterReset) {
        counterReset.appendChild(resetTag);
    }
});


document.addEventListener("DOMContentLoaded", function () {
    if (!document.body.classList.contains("single-product")) return;

	const previousUrl = document.referrer;
	const link = document.querySelector(".content-product-custom .link-back");

	if (!previousUrl || !link) return;

	try {
		const urlObj = new URL(previousUrl);
		const params = new URLSearchParams(urlObj.search);
		const validParams = ["_pa_brand", "_pa_model", "_product_cat"];
		const hasAnyParam = validParams.some(param => params.has(param));

		if (hasAnyParam) {
			link.href = previousUrl;
		}

	} catch (error) {
		console.error("URL invalid:", error);
	}
});

//scroll pagination function post_pagination
document.addEventListener("click", function (e) {
    const link = e.target.closest(".navigation.pagination a");

    if (link) {
        setTimeout(function () {
            const target = document.querySelector("#return-page-filter");
            if (target) {
                target.scrollIntoView({ behavior: "smooth" });
            }
        }, 300);
    }
});

